import { formatDate } from '../../../helpers/formatDate'
import type { TenantGroupDTO, EditRowDef } from '../../../types'

export function buildTenantGroupEditRows(group: TenantGroupDTO): EditRowDef[] {
  return [
    { mode: 'readonly', label: 'ID', value: <span className="font-monospace small">{group.id}</span> },
    { mode: 'readonly', label: 'Code', value: <span className="fw-medium">{group.code}</span> },
    { mode: 'editable', field: { name: 'name', label: 'Name', type: 'text', required: true }, initialValue: group.name },
    { mode: 'editable', field: { name: 'type', label: 'Type', type: 'text', required: true }, initialValue: group.type },
    {
      mode: 'editable',
      field: { name: 'availabilityBuildEnabled', label: 'Availability Build', type: 'checkbox' },
      initialValue: group.availabilityBuildEnabled,
    },
    { mode: 'readonly', label: 'Created', value: formatDate(group.createdAt) },
    { mode: 'readonly', label: 'Updated', value: formatDate(group.updatedAt) },
  ]
}
